module.exports = __webpack_public_path__ + "static/media/avatar-5.8d2ef531.png";